import React, { Fragment } from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Camera from '@material-ui/icons/CameraAlt';
import DeleteIcon from '@material-ui/icons/Delete';
import TextField from '@material-ui/core/TextField';

import pickupOrderRemote from '../../../api/pickupOrderRemote';

import whsOrderNoteStyles from './whsOrderNote.module.css';
import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    camera: {
      color: '#fff',
      fontSize: '20px',
      marginBottom: '5px',
      backgroundColor: 'var(--primaryblue)',
      border: '1px solid var(--primaryblue)',
      borderRadius: '50%',
      padding: '10px',
      cursor: 'pointer',
      boxSizing: 'content-box'
    },
    textField: {
      width: '100%',
      '& fieldset': {
        border: 'none !important',
      }
    },
    button: {
      marginBottom: '20px',
      marginTop: '10px',
      minWidth: '120px',
      marginRight: '12px',
      '&:last-child': {
        marginRight: '0'
      }
    },
    deleteIcon: {
      color: 'white',
      fontSize: '20px'
    },
  });

interface WhsOrderNoteProps {
  classes: any;
  note: string;
  orderNumber: string;
  attachments: string[];
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  returnToDriver: () => void;
  handleAttachmentDelete: (attachment: string) => void;
  handleAttachmentUpload: (event: any) => void;
  saveExit: (type: string) => void;
  type: string;
  onlyRead?: boolean;
};

const whsOrderNote = (props: WhsOrderNoteProps) => {

  const { classes, note, orderNumber } = props;

  const atachmentImages = props.attachments.map((attachment: string) => {
    return (
      <div className={whsOrderNoteStyles.attachmentContainer}>
        <img src={pickupOrderRemote.constructAttachmentUrl(attachment)} className={whsOrderNoteStyles.attachmentImage} />
        <div onClick={() => props.handleAttachmentDelete(attachment)} className={`${whsOrderNoteStyles.deleteAttachment} ${whsOrderNoteStyles.deleteAttachmentAlign}`}><DeleteIcon className={ classes.deleteIcon } /></div>
      </div>
    )
  });

  return (
    <div className={ whsOrderNoteStyles.wrapperTitle }>

      <div className={ whsOrderNoteStyles.headerTitle }>
        <span className={ whsOrderNoteStyles.poNumber }>{ orderNumber }</span>
        <span>Notes</span>
      </div>

      <div className={ `${ commonStyles.wrapper } ${ whsOrderNoteStyles.wrapper }` }>
        <h3 className={ commonStyles.header }> Notes</h3>
        <div className={ whsOrderNoteStyles.notesTextfield }>
          <TextField
            id="outlined-multiline-flexible"
            placeholder="-- Enter notes"
            multiline
            rows="6"
            rowsMax="6"
            value={ note || '' }
            onChange={ props.handleChange }
            variant="outlined"
            className={ classes.textField }
          />
        </div>
      </div>   

      <div className={`${commonStyles.wrapper} ${whsOrderNoteStyles.wrapper}`}>
        <div className={commonStyles.fSpaceBtw}>
          <h3 className={commonStyles.header}> Attachments </h3>
          <Fragment>
            <label htmlFor="fileUpload" className={`${whsOrderNoteStyles.uploadLabel} ${whsOrderNoteStyles.uploadLabelMargin}`}>
              <Camera className={classes.camera} />
            </label>
            <input id="fileUpload" type="file" name="attachment" className={whsOrderNoteStyles.fileUpload} onChange={props.handleAttachmentUpload} />
          </Fragment>
        </div>
        {atachmentImages}
      </div>
      

      <div className={whsOrderNoteStyles.buttonWrapper}>
        <Button
          color="primary" 
          variant="contained"
          onClick={ () => props.saveExit('save') }
          className={ classes.button }
        >Save and Exit
        </Button>
        <Button 
          color="primary" 
          variant="contained"
          onClick={ () => props.saveExit('exit') }
          className={ classes.button }
        >Exit
        </Button>
      </div>
      
    </div>
  );
};

export default withStyles(styles)(whsOrderNote);